if (!customElements.get('copy-link-button')) {
  customElements.define(
    'copy-link-button',
    class CopyLinkButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.copy-link-button');
        this.url = this.button.dataset.url;
        this.addEventListener('click', this.copyLink);
      }

      copyLink(e) {
        e.preventDefault();

        this.button.classList.add('active');

        navigator.clipboard.writeText(this.url);

        setTimeout(() => {
          this.button.classList.remove('active');
        }, 1000);
      }
    }
  );
}